import React from 'react';
import { Switch } from 'react-router-dom';
import { RouteWithPermissions } from 'containers/route-with-permissions';
import { BUSINNESS_FUNCTIONS } from 'constants/roles';
import { Index } from './downloadIndex';
import { FEATURE_TOGGLES } from 'constants/featureToggles';

export const DownloadRouting = () => {
    return (
        <Switch>
           <RouteWithPermissions
                path="/exception-management/charge-download/import"
                component={Index}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
                featuresToRestrict={[FEATURE_TOGGLES.FINOPS_BULK_DOWNLOAD_CHARGES]}
            />
            <RouteWithPermissions
                path="/exception-management/charge-download/export"
                component={Index}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
                featuresToRestrict={[FEATURE_TOGGLES.FINOPS_BULK_DOWNLOAD_CHARGES_EXPORTJOB]}
            />
        </Switch>
    );
};